const jpDays = ["日", "月", "火", "水", "木", "金", "土"];

export function getJpFullDate(date: Date) {
  return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日(${getJpDay(date)})`;
}

export function getJpShortDate(date: Date) {
  return `${date.getMonth() + 1}/${date.getDate()}(${getJpDay(date)})`;
}

export function getJpDay(date: Date) {
  return jpDays[date.getDay()];
}
